(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('Revision', Revision);

    Revision.$inject = ['$resource'];

    function Revision ($resource) {
        var resourceUrl =  'api/revisions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
